/** Line icons for the My Tools cards, 24-unit grid, drawn in the current text colour. All decorative: the control carries the name. */

function Icon({ className, children }: { className?: string; children: React.ReactNode }): React.JSX.Element {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      {children}
    </svg>
  );
}

/** Two overlapping sheets. */
export function CopyIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <Icon className={className}>
      <rect x="9" y="9" width="12" height="12" rx="2" />
      <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" />
    </Icon>
  );
}

/** A calendar with a plus: a second key, so the current one can run to its expiry. */
export function RenewIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <Icon className={className}>
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18M12 13v5M9.5 15.5h5" />
    </Icon>
  );
}

/** Two arrows chasing each other: swap the key for a new one. */
export function RotateIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <Icon className={className}>
      <path d="M21 12a9 9 0 0 0-15.5-6.2L3 8" />
      <path d="M3 3v5h5" />
      <path d="M3 12a9 9 0 0 0 15.5 6.2L21 16" />
      <path d="M21 21v-5h-5" />
    </Icon>
  );
}

/** A circle struck through: stop the key. */
export function RevokeIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <Icon className={className}>
      <circle cx="12" cy="12" r="9" />
      <path d="m5.7 5.7 12.6 12.6" />
    </Icon>
  );
}

/** Angle brackets: code examples. */
export function CodeIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <Icon className={className}>
      <path d="m16 18 6-6-6-6M8 6l-6 6 6 6" />
    </Icon>
  );
}

/** A box with an arrow leaving it: a link that opens in a new tab. */
export function ExternalIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <Icon className={className}>
      <path d="M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    </Icon>
  );
}

/** A tick: done. */
export function CheckIcon({ className }: { className?: string }): React.JSX.Element {
  return (
    <Icon className={className}>
      <path d="m5 12 5 5 9-10" />
    </Icon>
  );
}
